import { useEffect, useState } from "react";
import { Rocket, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { STATES } from "@/lib/constants";

let cache = null;
export function useOpenStates() {
  const [open, setOpen] = useState(cache);
  useEffect(() => {
    if (!cache) api.get("/states").then((r) => { cache = r.data.open; setOpen(cache); });
  }, []);
  return open;
}

export function WaitlistBanner({ region }) {
  const open = useOpenStates();
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setDone(false); }, [region]);
  useEffect(() => { if (user?.email) setEmail(user.email); }, [user]);

  if (!open || region === "ALL" || open.includes(region)) return null;
  const name = STATES.find((s) => s.id === region)?.name || region;

  const join = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/waitlist", { email, state: region }); setDone(true); } catch (e2) { toast.error(formatErr(e2)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="waitlist-banner" className="flex flex-col gap-4 rounded-2xl border border-[#d4f253]/40 bg-[#d4f253]/10 p-5 md:flex-row md:items-center">
      <Rocket className="h-8 w-8 shrink-0 text-[#d4f253]" />
      <div className="flex-1">
        <p className="font-display font-bold">Coming soon to {name}</p>
        <p className="text-sm text-slate-300">ISoldIt is launching in Queensland first. You can already list and browse here. Join the waitlist and we'll email you when we officially open in {name}.</p>
      </div>
      {done ? (
        <p data-testid="waitlist-success" className="flex items-center gap-2 text-sm font-semibold text-[#d4f253]"><CheckCircle2 className="h-5 w-5" />You're on the list!</p>
      ) : (
        <form onSubmit={join} className="flex w-full gap-2 md:w-auto">
          <input data-testid="waitlist-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="h-11 min-w-0 flex-1 rounded-full bg-white px-4 text-sm text-[#0f2a33] outline-none md:w-56" />
          <button data-testid="waitlist-join-btn" disabled={busy} className="btn-lime h-11 shrink-0 px-5 text-sm">Notify me</button>
        </form>
      )}
    </div>
  );
}
